"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalSheetContext = void 0;
var react_1 = require("react");
exports.ApprovalSheetContext = react_1.createContext({
    sheet: {},
    currentUserId: '',
    isAdmin: false,
    saveApprovalSheetGroups: function () { return Promise.resolve(); },
    changeApprovalSheetStatus: function () { return Promise.resolve(); },
    updateApprovalSheet: function () { return Promise.resolve(); },
    sendApprovalSheetResolution: function () { return Promise.resolve(); },
    getAllUsers: function () { return Promise.resolve([]); },
});
